import React from "react";

export const InjectProps = <CProps, InjectedProps = any>(
    Component: React.JSXElementConstructor<CProps>,
    injector: InjectedProps
): React.ElementType => {
    const Injected = (props: CProps) => {
        return <Component {...props} {...injector} />;
    };

    return Injected;
};
